import React, {createContext, useEffect} from "react";
import {getCookie} from "helpers/common";
import notificationSocketService from "services/notificationSocketService";
import {useAuthContext} from "Context/authContext";
import {useSelector} from "react-redux";

const context = {
    socket: null,
};

export const SocketContext = createContext(context);

export function SocketContextProvider(props) {
    const {isLoggedIn} = useAuthContext();
    const access_token = getCookie(process.env.REACT_APP_FOODIE_TOKEN_COOKIE);
    const defaultStore = useSelector(state => state.business.defaultStore);
    const selectedStoreId = useSelector(state => state.business.selectedStoreId);

    const activeStoreId = selectedStoreId || defaultStore;

    useEffect(() => {
        // Connect to notification service (central hub for all events)
        if (access_token && activeStoreId && isLoggedIn) {
            console.log("🔌 [SocketContext] Connecting to notification service...", {
                hasToken: !!access_token,
                storeId: activeStoreId,
                selectedStoreId,
                defaultStore,
                isLoggedIn,
            });

            // Disconnect existing connection first if any
            if (notificationSocketService.isConnected()) {
                console.log("🔌 [SocketContext] Disconnecting existing connection before reconnecting to new store");
                notificationSocketService.disconnect();
            }

            setTimeout(() => {
                notificationSocketService.connect(access_token, activeStoreId);
            }, 1000);
        }

        return () => {
            // Disconnect when component unmounts or user logs out
            if (!isLoggedIn) {
                console.log("🔌 [SocketContext] Disconnecting from notification service");
                notificationSocketService.disconnect();
            }
        };
    }, [access_token, isLoggedIn, activeStoreId]);

    return (
        <SocketContext.Provider value={{socket: notificationSocketService.getSocket()}}>
            {props.children}
        </SocketContext.Provider>
    );
}
